import $ from 'jquery'
import Isotope from 'isotope-layout'
import { debounce } from '../functions'

const initializeBlock = function ($block) {
  const row = $block.find('.lexical-block__row')
  const filter = $block.find('.filter__autocomplete')

  const iso = new Isotope(row[0], {
    itemSelector: '.feed-lexical',
    percentPosition: true,
    masonry: {
      columnWidth: '.feed-lexical--sizer',
    },
  })

  let qsRegex

  const search = filter.keyup(
    debounce(function () {
      qsRegex = new RegExp(search.val(), 'gi')

      iso.arrange({
        filter: function () {
          return qsRegex ? $(this).find('.feed-lexical__title').text().match(qsRegex) : true
        },
      })
    }, 200)
  )
}

$('.lexical-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction('render_block_preview/type=nrj-lexical', initializeBlock)
}
